export default __webpack_public_path__ + "static/media/Stalker's Gloves of the Grim Cabal.bb158a3d.jpg";